<template>
  <OverlayScrollbars 
    class="chips-scroller" 
    :options="chipsScrollOptions">
    <div class="filter-chip-container">
      <FilterChip 
        v-for="chip of chips"
        :key="chip.value?.value || chip.display"
        @click="removeChip(chip)"
        :display="chip.display"
        :value="chip.value"
        :filter="chip.filter" />
    </div>
  </OverlayScrollbars>
</template>

<script setup lang="ts">
import { watch, reactive } from 'vue';
import { useQueryStore } from '@/store/query';
import { AnyFilterDefinition, DateRangeFilterDefinition, FilterChip, RangeFilterDefinition, VoyagerSelectFilterValues } from 'VoyagerComponents';
import { storeToRefs } from 'pinia';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';


dayjs.extend(utc); // use UTC plugin

const { getAppliedFilters } = storeToRefs(useQueryStore());
type Chip = { display: string, value: VoyagerSelectFilterValues | undefined, filter: AnyFilterDefinition }

// //convert daterange to shortened string
// const dateString = (date: Date) => {
//   const month = date.toLocaleString('default', { month: 'short' });
//   const day = date.getDate();
//   const year = date.getFullYear();
//   return `${month} ${day}, ${year}`;
// }

const rangeDisplayValue = (filter: RangeFilterDefinition | DateRangeFilterDefinition) => {
  const { start, end } = filter;
  if(start && end) return `${start} - ${end}`;
  if(start) return `> ${start}`;
  if(end) return `< ${end}`;
  return '';
}

const chips: Chip[] = reactive([]);
const emit = defineEmits(['userAction']);
const chipsScrollOptions = {
    scrollbars: {
      theme: 'os-theme-light',
    },
  }

const removeChip = (chip: Chip) => {
  if(chip.filter.type === 'multi' || chip.filter.type === 'single') {
    emit('userAction', { action: 'toggleSelectFilterValue', filterName: chip.filter.name, filterValue: chip.value?.value })
  } else if (chip.filter.type === 'range' || chip.filter.type === "dateRange" || chip.filter.type === "fileSize") {
    emit('userAction', { action: 'removeFilter', filterName: chip.filter.name })
  }
}

watch(getAppliedFilters, (next) => {
  chips.splice(0, chips.length);
  next.forEach((filter) => {
    if(filter.type === 'multi' || filter.type === 'single') {
      filter.availableValues.filter(v => v.selected).forEach((value) => {
        chips.push({ display: value.valueDisplay || value.value, value: value, filter: filter })
      })
    } else if (filter.type === 'range' || filter.type === "dateRange" || filter.type === "fileSize") {
      chips.push({ display: rangeDisplayValue(filter), value: undefined, filter: filter })
    }
  })
  return chips;
}, {deep: true, immediate: true})
</script>

<style scoped lang="scss">

  .chips-scroller {
    max-height: 4.25rem;
  }
  .filter-chip-container {
    display: flex;
    flex-wrap: wrap;
    column-gap: .25rem;
    row-gap: .25rem;
    flex-direction: row;
    margin-right: 1rem;
    margin-left: 1rem;
    // max-height: 4.25rem;
    // overflow-y: hidden;
    // position: relative;
  }
</style>